import { render, staticRenderFns } from "./NewFeedItem.vue?vue&type=template&id=452922d6&scoped=true&"
import script from "./NewFeedItem.vue?vue&type=script&lang=js&"
export * from "./NewFeedItem.vue?vue&type=script&lang=js&"
import style0 from "./NewFeedItem.vue?vue&type=style&index=0&id=452922d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452922d6",
  null
  
)

export default component.exports